module.exports = __webpack_public_path__ + "static/media/mapZastava.98cf084e.png";